import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "card reports-referrer"
}
const _hoisted_3 = {
  key: 0,
  class: "report-container"
}
const _hoisted_4 = { class: "table-total" }
const _hoisted_5 = { class: "label-text-total" }
const _hoisted_6 = { class: "report-referrer-container" }
const _hoisted_7 = { class: "report-chart" }
const _hoisted_8 = { class: "report-source-color" }
const _hoisted_9 = { class: "label-text-source-background" }
const _hoisted_10 = { class: "reports-container-table" }
const _hoisted_11 = { class: "report-table" }
const _hoisted_12 = { class: "first-row" }
const _hoisted_13 = { class: "last-row" }
const _hoisted_14 = { class: "last-row" }
const _hoisted_15 = {
  key: 1,
  class: "report-no-data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "chart-title-referrer" }, [
          _createElementVNode("h2", { class: "title-main" }, "Leads Report")
        ], -1)),
        ($setup.filteredDataFromAnalytics.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "label-text-total" }, "Leads created:", -1)),
                _createElementVNode("span", _hoisted_5, _toDisplayString($setup.calculateGrandTotal()), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "label-text-lead" }, "Lead Source", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.chartData.source, (source, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "source-container-color",
                        key: index
                      }, [
                        _createElementVNode("div", {
                          class: "background-color",
                          style: _normalizeStyle({ backgroundColor: $setup.backgroundColorForLeadsReport[index] })
                        }, null, 4),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(source), 1)
                      ]))
                    }), 128))
                  ]),
                  _createVNode($setup["MixedChart"], {
                    data: $setup.chartData,
                    options: $setup.optionsBarChartForLeadsReport
                  }, null, 8, ["data", "options"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("table", null, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _cache[2] || (_cache[2] = _createElementVNode("th", { class: "first-row" }, "Lead Source", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tableData, (estate) => {
                            return (_openBlock(), _createElementBlock("th", _hoisted_12, _toDisplayString(estate.estate), 1))
                          }), 256)),
                          _cache[3] || (_cache[3] = _createElementVNode("th", { class: "first-row" }, "Lead count", -1))
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.chartData.source, (source, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, _toDisplayString(source), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tableData, (estate) => {
                              return (_openBlock(), _createElementBlock("td", null, _toDisplayString(estate.count[index]), 1))
                            }), 256)),
                            _createElementVNode("td", null, _toDisplayString($setup.getTotalForSource(source)), 1)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("tfoot", null, [
                        _createElementVNode("tr", null, [
                          _cache[4] || (_cache[4] = _createElementVNode("th", { class: "last-row" }, null, -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tableData, (estate) => {
                            return (_openBlock(), _createElementBlock("th", _hoisted_13))
                          }), 256)),
                          _createElementVNode("th", _hoisted_14, _toDisplayString($setup.calculateGrandTotal()), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("h2", { class: "subtitle-main" }, "No data to display", -1)
            ]))]))
      ]))
}